<template>
  <el-card shadow="hover">
    <label slot="header">JStep步骤（多个分组时需要使用不同父元素包裹各自组内的j-step）</label>
    <el-divider content-position="left">基本属性用法 | 插槽用法 | 内容空状态 | 长文本样式</el-divider>
    <div>
      <JStep title="title属性标题" description="description属性内容" required />
      <JStep>
        <div slot="title">插槽标题</div>
        <div>插槽内容</div>
      </JStep>
      <JStep title="内容空状态，跟换圆环主题色" circle-color="#01B963" />
      <JStep title="超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字">
        <div style="height: 60px">
          超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字
          超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字超长文字
        </div>
      </JStep>
    </div>
  </el-card>
</template>

<script>
import JStep from "@/components/JComponents/JStep/JStep.vue";
export default {
  components: {
    JStep
  },
  data() {
    return {}
  },
  created() {

  },
  methods: {}
}
</script>

<style scoped>

</style>
